module.exports = __webpack_public_path__ + "static/media/DqEveryChildChallengePhoto1.ea227447.jpg";